import { c as _c } from "react-compiler-runtime";
import { fromPromise } from 'pulse/adapters';
import { defineMutation } from 'pulse/mutations';
import { useMutation, useResource } from 'pulse/react';
import { defineResource } from 'pulse/resources';
import { toSuccess } from 'pulse/resolvers';
import { getLocalStore } from '../utils/superstore';
const LocalStoreValueResource = defineResource({
  typeName: 'framework-listing-lib:LocalStoreValue',
  args: ['key'],
  resolver: fromPromise('readLocalStore', ({
    key
  }) => getLocalStore().get(key).then(value => {
    return {
      key,
      value
    };
  }))
}).register();
const WriteLocalStore = defineMutation({
  typeName: 'framework-listing-lib:WriteLocalStore',
  async mutation({
    key,
    value
  }) {
    const result = await getLocalStore().set(key, value);
    return {
      key,
      value: result
    };
  },
  optimistic({
    params,
    setState
  }) {
    setState({
      resource: LocalStoreValueResource,
      params: {
        key: params.key
      },
      state: toSuccess({
        key: params.key,
        value: params.value
      })
    });
  },
  resolved({
    result,
    setState,
    invalidate
  }) {
    if (result.value === null) {
      invalidate({
        resource: LocalStoreValueResource,
        params: {
          key: result.key
        }
      });
      return;
    }
    setState({
      resource: LocalStoreValueResource,
      params: {
        key: result.key
      },
      state: toSuccess(result)
    });
  }
});
export function useReadLocalStore(key, options) {
  "use memo";

  const $ = _c(5);
  let t0;
  if ($[0] !== key) {
    t0 = {
      key
    };
    $[0] = key;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = options === null || options === void 0 ? void 0 : options.skip;
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = {
      params: t0,
      skip: t1
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return useResource(LocalStoreValueResource, t2);
}
export function useWriteLocalStore() {
  "use memo";

  return useMutation(WriteLocalStore);
}